<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">Acknowledgments</p>
<p class="ack">This book would not have been possible without the immeasurable contribution of my husband, Vaughn. His practical intuitiveness, technical proficiency, and unrelenting commitment to a deadline are the reasons you are able to hold this book in your hands.</p>
<p class="ack">His engineering background has twice proved useful in my career as a crazy-quilt maker—with this book and previously in his contribution on my first book, <i>Foolproof Crazy Quilting</i>. He manages to decipher the ideas and shapes in my head and translate them into patterns on paper that anyone who has never even picked up a needle before can use to create wonderful, crazy patterns.</p>
<p class="ack">I am also grateful to the many people who have come together to make this book happen.</p>
<p class="ack1">To Liz and the talented team at C&amp;T Publishing, thank you.</p>
<p class="ack1">To my friend and neighbor Jane, who donned many hats during my book-writing process—therapist, patient listener, quality controller, and a calming influence. Thank you.</p>
<p class="ack1">To my children, Gareth and Ainslie, thank you for replying to my desperate calls for help regarding color choice and design.</p>
<p class="ack1">Lastly, to my students, who encourage, motivate, and stimulate me. You asked the question: “Have you started your next book?” My answer is, “Yes, I have, and here it is.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_ack.vue?55821214